<div id='backdrop' class='modal-backdrop' [ngClass]='{ show: showModal }'></div>
<div class='modal d-block fade' 
[ngClass]='{ show: showModal }'
(click)='goBack()'
id='listing-dialog' 
tabindex='-1' role='dialog' aria-labelledby='modalIdLabel'>
<div class='modal-dialog mw-100 w-75' role='document' (click)='onDialogClick($event)'>
<div class='modal-content'>
    <div class='modal-header'>
        <h5 *ngIf='showModal'>Datei importieren</h5>
        <button type='button'
            class='close'
            (click)='goBack()'
            aria-label='Close'><span aria-hidden='true'>&times;</span>
        </button>
    </div>
    <div class='modal-body'>
        <div class="import-container">
            <h2>Datei importieren</h2>
            
            <div class="upload-area" 
                 (dragover)="onDragOver($event)"
                 (drop)="onDrop($event)">
                
                <input #fileInput
                       type="file" 
                       [accept]="allowedFileTypes.join(',')"
                       (change)="onFileSelected($event)"
                       style="display: none">
                
                <div class="upload-content" *ngIf="!selectedFile">
                    <i class="fas fa-cloud-upload-alt"></i>
                    <p>Ziehen Sie eine Datei hierher oder</p>
                    <button class="btn-primary" (click)="triggerFileInput()">
                        Datei auswählen
                    </button>
                    <p class="file-info">Erlaubte Formate: CSV, Excel (max. 5MB)</p>
                </div>

                <div class="selected-file" *ngIf="selectedFile">
                    <i class="fas fa-file"></i>
                    <p>{{ selectedFile.name }}</p>
                    <button class="btn-secondary" (click)="resetUpload()">
                        Entfernen
                    </button>
                </div>
            </div>

            <div class="upload-progress" *ngIf="isUploading">
                <div class="progress-bar">
                    <div class="progress" [style.width.%]="uploadProgress"></div>
                </div>
                <p>{{ uploadProgress }}%</p>
            </div>

            <button class="btn-primary upload-btn" 
                    [disabled]="!selectedFile || isUploading"
                    (click)="uploadFile()">
                {{ isUploading ? 'Wird hochgeladen...' : 'Hochladen' }}
            </button>

            <div class="checkbox-container mt-3">
                <div class="form-check">
                    <input type="checkbox" 
                           class="form-check-input" 
                           id="calculateCheckbox" 
                           [(ngModel)]="calculateOnImport">
                    <label class="form-check-label" for="calculateCheckbox">
                        Berechnung beim Import durchführen
                    </label>
                </div>
            </div>

            <!-- Importstatistik -->
            <div class="import-statistics" *ngIf="showStatistics">
                <div class="statistics-box">
                    <p>Aufträge importiert: <strong>{{ importCount }}</strong></p>
                    <p>Davon mit Kalkulation: <strong>{{ calculationCount }}</strong></p>
                </div>
            </div>
        </div>
    </div>
</div>
</div>
</div>
